import { APP_CONFIG, returnOrThrow, getWrapper } from "./util";

export const appConfig = async () => {
  const resJSON = await getWrapper(APP_CONFIG);
  const result = await returnOrThrow(resJSON);
  return result;
};
